function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.018 13.632c1.654-1.355 4.743-4.356 4.743-7.871a5.761 5.761 0 00-11.522 0c0 3.515 3.089 6.516 4.743 7.871.59.491 1.446.491 2.036 0zM7 7.041A1.92 1.92 0 106.999 3.2 1.92 1.92 0 007 7.041z"
});

function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAxNCI+CiAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTguMDE4IDEzLjYzMmMxLjY1NC0xLjM1NSA0Ljc0My00LjM1NiA0Ljc0My03Ljg3MUMxMi43NjEgMi41NzkgMTAuMTgxIDAgNyAwIDMuODE4IDAgMS4yMzkgMi41OCAxLjIzOSA1Ljc2MWMwIDMuNTE1IDMuMDg5IDYuNTE2IDQuNzQzIDcuODcxLjU5LjQ5MSAxLjQ0Ni40OTEgMi4wMzYgMHpNNyA3LjA0MWMxLjA2IDAgMS45Mi0uODYgMS45Mi0xLjkyUzguMDYgMy4yMDEgNyAzLjIwMXMtMS45Mi44Ni0xLjkyIDEuOTIuODYgMS45MiAxLjkyIDEuOTJ6Ii8+Cjwvc3ZnPgo=";
export { SvgMap as ReactComponent };